import React from "react";

const ModalOverlay = ({
  children,
  style,
  onPress = null,
  animation_type = "fadeIn",
  disabled = false
}) => {
  return (
    <div
      onClick={onPress && !disabled ? onPress : () => {}}
      className={
        disabled
          ? ""
          : "deal-modal-overlay animated animate_delay_025s " + animation_type
      }
    >
      <div
        style={
          !disabled
            ? {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "fixed",
                top: "var(--new-dm-banner-offset, 0px)",
                left: 0,
                width: "100%",
                height: "calc(100% - var(--new-dm-banner-offset, 0px))"
              }
            : null
        }
      >
        {children}
      </div>
    </div>
  );
};

export { ModalOverlay };
